import React from 'react'
import styled from 'styled-components'

const StButton = styled.a``

const Button = ({ as = 'a', href, children, className = '', ...rest }) => {
  return (
    <StButton
      as={as}
      className={`font-normal text-sm sm:text-md lg:text-base sm:font-bold py-2 md:px-4 px-1 border-2 hover:bg-white hover:text-azul rounded-md transition duration-300 ease-in-out focus:outline-none focus:shadow-outline ${
        className ? className : ' bg-azul text-white border-azul'
      }`}
      href={href}
      {...rest}>
      {children}
    </StButton>
  )
}

export default Button

// inline-flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-indigo-600 bg-white hover:text-indigo-500 focus:outline-none focus:shadow-outline transition duration-150 ease-in-out
